import {AppProps} from "next/app";
import {wrapper} from "@/store/store";
import {Provider} from "react-redux";
import {ThemeProvider} from "styled-components";
import theme from "@/styles/themes/index";
import GlobalStyle from "@/styles/default";
import Loading from "@/components/loading";
import {useEffect} from "react";
import {InitLoadEvents} from "@/utils/Events";
import Apm from "@/utils/Apm";

export default function App({Component, ...rest}: AppProps) {
    const {store, props} = wrapper.useWrappedStore(rest)
    const {pageProps} = props;

    Apm.init();

    useEffect(() => {
        InitLoadEvents();
    }, [])

    if (typeof window != "undefined") {
        window.addEventListener("error", function (event) {
            Apm.captureError(`GLOBAL_ERROR: ${event.error}`)
        });
    }
    
    return (

        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <Loading></Loading>
                <GlobalStyle></GlobalStyle>
                <div className={'container'}>
                    <Component {...pageProps}></Component>
                </div>
            </ThemeProvider>
        </Provider>
    )
}